import React from "react";
import { AmplifyAuthenticator } from "@aws-amplify/ui-react";
import { LoginRedirectComponent } from "../login-redirect/login-redirect.component";

export const AmplifyLoginComponent = () => {
  return (
    <div className="aws-breaker">
      <div className="aws-breaker-el" />
      <div className="aws-breaker-el-1" />
      <div className="aws-breaker-el-2" />
      <div className="aws-breaker-el-3" />
      <AmplifyAuthenticator>
        <LoginRedirectComponent />
      </AmplifyAuthenticator>
    </div>
  );
};
